export { default } from './text-input'
export type { TProps as TextInputProps } from './text-input'
